import { useCallback } from 'react'

import { ContentViewerActions } from '@/content-viewer/store/slice'
import { useAppDispatch } from '@/store/store-hooks'
import { useDraftWorkspace } from './useDraftWorkspace'

/**
 * Leaves the draft for the conversation on a small screen, closing any source left open behind it. A screen too narrow
 * for the chat panel shows a source in a slideover over the chat, and the source can only be one opened before the
 * screen was narrowed.
 *
 * The source closes here, with the control that leaves, rather than off the draft closing: the slideover would
 * otherwise mount and animate away. Leaving the draft any other way, browser navigation included, keeps the source.
 */
export function useLeaveDraftOnSmallScreen() {
  const dispatch = useAppDispatch()
  const { closeDraft } = useDraftWorkspace()

  return useCallback(() => {
    dispatch(ContentViewerActions.clearContentViewer())
    closeDraft()
  }, [closeDraft, dispatch])
}
